/**
 * Classe view para o Crud de Rotas
 * @author Adalto Junior
 * Date: 18/02/2013
 */

App.Views.Route = {

  adjustFormAndShowTreeview: function (nodes) {
    const selector = "#Route #treeViewForm #routeTreeview";
    if (!document.querySelector(selector)) {
      const formSelector = "#Route .MonetUIForm";
      const formRouteHtml = document.querySelector(formSelector);
      const divNodeTreeview = document.createElement("div");
      const divChildTreeview = document.createElement("div");
      divNodeTreeview.setAttribute("id", "treeViewForm");
      divChildTreeview.setAttribute("id", "routeTreeview");
      formRouteHtml.classList.add('adjustEditStageCrud');
      formRouteHtml.parentNode.insertBefore(divNodeTreeview, formRouteHtml);
      divNodeTreeview.appendChild(divChildTreeview);
    }
    this.nodes = nodes;
    const treeView = new Greenmile.Treeview(selector);
    treeView.createTreeView(
        this.nodes,
        ["themes", "json_data", "crrm", "ui"]
    );
    treeView.eventListenerSelectNode();
  },

    removeNodesClickedInTreeView: function () {
        const treeViewNodes = document.querySelectorAll('#treeViewForm #routeTreeview li > ul li');

        treeViewNodes.forEach(node => {
            const linkElementIndex = 1;

            node.children[linkElementIndex].classList.remove('jstree-clicked')
        })
    },

    setDefaultDateToPlanned: function () {
        var dateUtil = new Monet.Date.GeneralFunctions();
        var actualDate = dateUtil.getCurrentDateAndTime();
        var fields = App.Forms.Route.form.fields;

        fields.date.setValue(new Date().getTime());
        fields.plannedStart.input.value = actualDate;
        fields.plannedDeparture.input.value = actualDate;
        fields.plannedArrival.input.value = actualDate;
        fields.plannedComplete.input.value = actualDate;
    },

    addEventListenners: function () {

        var formFields = App.Forms.Route.form.fields;
        var lastStopIsDestination = formFields.lastStopIsDestination;

        var lastStopDestinationEvent = function () {

            var destinationField = formFields.destination;

            if (this.checked) {
                destinationField.clear();
                destinationField.disable();
            } else {
                destinationField.enable();
            }
        };

        lastStopIsDestination.input.removeEventListener("click", lastStopDestinationEvent);
        lastStopIsDestination.input.addEventListener("click", lastStopDestinationEvent);

    },

    routeIsStarted: function () {

        var error           = null,
            actualDeparture = null,
            isStarted       = false;

        try {

            actualDeparture = App.Forms.Route.form.fields.actualDeparture;

            if (actualDeparture && actualDeparture.getValue() !== "") {
                isStarted = true;
            }

            return isStarted;

        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on verify route is started.");
            error.console();
        }
    },

    addChangeOrganizationButton: function() {
        const fieldList = App.Forms.Route.form.fields;
        const field = fieldList.organization;
        const value = field.value;

        const onClick = () => {
            const changeOrganizationAction = () => {
                field.enable();
                field.clear();
            };

            new Greenmile.Components.AlertModal("Route.Confirm.ChangeOrganization",
                null,
                changeOrganizationAction)
            .show();
        };

        const label = Monet.I18n.getResourcesByKey('route.change.organization');
        const fieldRender = new Monet.UI.Fields.Render({
            label: label
            ,type: 'BUTTON'
            ,name: "changeOrganization"
            ,customJavaScript: onClick
        }, 'Route');

        const button = fieldRender.render().render();
        button.setAttribute('title', label);

        if(!field.getDefaultValue()) {
            field.setDefaultValue({ ...value })
        }

        const sucessRequest = () => field.disable();
        const errorRequest = () => {
            const defaultValue = field.getDefaultValue();
            if(defaultValue) {
                field.setValue(defaultValue)
                field.disable();
            }
        }

        const organizationContainer = document.querySelector('#Route #Route_organization');
        organizationContainer.appendChild(button);
        field.addListenerToAfterSelectRow((organizationRow) => {
            App.Objects.Route.updateRouteOrganization(
                fieldList.id.getValue(),
                organizationRow.id,
                sucessRequest,
                errorRequest
            );
        });
    }
};
